import React, { useRef, useState } from 'react';
import BarcodeScannerWrapper from './BarcodeScannerWrapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import { useScannerSettings } from '../providers/ScannerSettingsContext';
import ScanModal from './ScanModal';
import { isMobileDevice } from './utils/utils.js';



const ScannerLauncher = ({ onBarcodeDetected, mode, buttonClasses }) => {
  const { scannerType } = useScannerSettings();
  const [showScanner, setShowScanner] = useState(false);
  const beepRef = useRef(null);

  const handleStartScan = async () => {
    try {
      if (scannerType === 'mobile') {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        stream.getTracks().forEach(track => track.stop());

        const unlockAudio = new Audio('/silence.mp3');
        unlockAudio.play().catch(() => { });
      }
      setShowScanner(true);
    } catch (err) {
      console.error('Camera access denied or failed:', err);
      alert('Camera access is required to scan barcodes.');
    }
  };

  return (
    <>
      {isMobileDevice() && (
        <div>
          {mode === 'floating' && (
            <button className="btn btn-link me-2 mobile-scanner-button" onClick={handleStartScan}>
              <FontAwesomeIcon icon={faBarcode} />
            </button>
          )}

          {mode === 'button' && (
            <button type="button" className={`btn btn-secondary ${buttonClasses}`} onClick={handleStartScan}>
              Scan
            </button>
          )}

          <audio ref={beepRef} src="/beep.wav" preload="auto" />

          {showScanner && (scannerType === 'mobile') && (
            <BarcodeScannerWrapper
              show={true}
              onClose={() => setShowScanner(false)}
              onBarcodeDetected={(barcode) => {
                setShowScanner(false);
                onBarcodeDetected(barcode);
              }}
              beepRef={beepRef}
            />
          )}
          {showScanner && (scannerType !== 'mobile') && (
            <ScanModal show={true} onClose={() => setShowScanner(false)} onBarcodeDetected={(barcode) => {
              setShowScanner(false);
              onBarcodeDetected(barcode);
            }} />
          )}
        </div>

      )}
    </>
  );
};

export default ScannerLauncher;
